import * as React from "react";

interface IProps {
    className?: string;
    visible?: boolean;
    feature: any;
    layerId: string;
    panToFeature?: (feature: any) => void;
}

export default function LayerListRowFeature (props: IProps) {
    const {className = '', feature, panToFeature: panToFeatureCallback} = props;

    const featureName = React.useMemo(() => {
        return feature.getIn(['properties', 'name']);
    }, [feature])

    const panToFeature = React.useCallback(() => {
        if (panToFeatureCallback) {
            panToFeatureCallback(feature.toJS());
        }
    }, [panToFeatureCallback, feature])

    return <div>
        <div className={`layerListRowFeature ${className}`}  onClick={panToFeature}>
            <div>
                {/*<span className={`btn fas ${visibleClass}`}*/}
                {/*onClick={this.toggleFeature}/>*/}
                <span> {featureName}</span>
            </div>
            <div className={`layerListRowMenu`}>
                <span className={`btn fas fa-arrow-right`}/>
            </div>
        </div>
    </div>
}
